export default __webpack_public_path__ + "static/media/role-black-icon.52ce2c38.svg";